import ErrorBar from './ErrorBar';

export default ErrorBar;
